"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SDKProvider", {
  enumerable: true,
  get: function get() {
    return _SDKProvider["default"];
  }
});
Object.defineProperty(exports, "uuidv4", {
  enumerable: true,
  get: function get() {
    return _uuid.uuidv4;
  }
});

var _EventNames = _interopRequireDefault(require("./Common/EventNames"));

var _SDKProvider = _interopRequireDefault(require("./SDKProvider"));

var _EventManager = _interopRequireDefault(require("./Utils/EventManager"));

var _uuid = require("./Utils/uuid");

// Entry point
(function () {
  // Declares window object for NodeJS environment
  if (global.window === undefined) {
    global.window = global;
  }

  if (!window) {
    throw new Error("window object not found");
  } // Check existence of global objects to avoid overwrite/clashing


  if (!("Microsoft" in window)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.Microsoft = {};
  }

  if (!("CRM" in window.Microsoft)) {
    window.Microsoft.CRM = {};
  }

  if (!("Omnichannel" in window.Microsoft.CRM)) {
    window.Microsoft.CRM.Omnichannel = {};
  }

  if (!("SDK" in window.Microsoft.CRM.Omnichannel)) {
    window.Microsoft.CRM.Omnichannel.SDK = {
      SDKProvider: _SDKProvider["default"],
      Util: {
        uuidv4: _uuid.uuidv4
      }
    };
  }

  window.document && _EventManager["default"].raiseCustomEvent(_EventNames["default"].OCSDKLOAD);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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